import { useAuth } from '@wui/common-library'
import { unix } from 'dayjs'
import jwtDecode from 'jwt-decode'
import { computed, ref } from 'vue'

const now = ref(unix(Date.now() / 1000))
setInterval(() => {
  now.value = unix(Date.now() / 1000)
}, 5000)

export const useAuthApiTokenValidator = () => {
  const { token } = useAuth()
  const isValid = computed(() => {
    if (!token.value) {
      return false
    }
    try {
      const { exp } = jwtDecode<{ exp: number }>(token.value)
      return unix(exp).isAfter(now.value)
    } catch {
      return false
    }
  })

  return {
    isValid,
  }
}
